import { render, staticRenderFns } from "./noticeComponent.vue?vue&type=template&id=51f64c75&scoped=true"
import script from "./noticeComponent.vue?vue&type=script&lang=js"
export * from "./noticeComponent.vue?vue&type=script&lang=js"
import style0 from "./noticeComponent.vue?vue&type=style&index=0&id=51f64c75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f64c75",
  null
  
)

export default component.exports